module.exports = __webpack_public_path__ + "media/images/logos/TheStar-logo-d7619a5d197358726f848a8194e3b6c7.svg";